import React from 'react';
import scrollToComponent from 'react-scroll-to-component';
import {HomeBanner, HomeCategories, HomeSales, HomeAbout, HomeTimeline, News} from '../components';

const options = {
  align: "top",
  scrollDuration: 400, //500 ms
  offset: -110 //Header + 10px
};

class HomePage extends React.Component {
  scrollToCategories = () => {
    scrollToComponent(this.categoriesRef, options);
  };

  setRef = (input) => {
    this.categoriesRef = input;
  };

  render() {
    return (
      <div>
        <HomeBanner
          scrollToCategories={this.scrollToCategories}
          langs={{
            imgAlt: this.props.texts.gen.imgAlt
          }}
        />
        <HomeCategories
          langs={{
            surgery: this.props.texts.langs.surgery
          }}
          setRef={this.setRef}
        />
        <HomeSales
          langs={{
            sales: this.props.texts.langs.sales,
            imgAlt: this.props.texts.gen.imgAlt
          }}
        />
        <HomeAbout
          langs={{
            imgAlt: this.props.texts.gen.imgAlt
          }}
        />
        <HomeTimeline/>
        <News
          langs={{
            news: this.props.texts.langs.news,
            imgAlt: this.props.texts.gen.imgAlt
          }}
        />
      </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/containers/HomePage.js